import 'fitvids.js';

export default {
  init() {
    // JavaScript to be fired on all pages
    $('#menu-social-menu a, .custom_banners_big_link').attr('aria-label', 'Social link');
    const settings = window.ThemeSettings;
    const form = $('.mailchimp-widget form');
    const button = form.find('input[type=submit]')[0];
    const notification = $('.mc-notification');
    let timeout;
    form[0]._wpnonce.value = settings.wpnonce;
    form.submit( e => {
      e.preventDefault();
      button.disabled = true;
      window.clearTimeout(timeout);
      window.grecaptcha.ready( () => {
        window.grecaptcha.execute(settings.recaptcha_key).then(function(token) {
          form[0].response.value = token;
          $.ajax({
            type: 'POST',
            url: settings.action_url,
            data: form.serialize(),
            success: response => {
              if (response.success) {
                notification.text('Tack för ditt interesse!');
              } else {
                notification.text(response.data.code === 'wrong_email' ? 'Feil email' : response.data.code);
              }
              form.css('opacity', 0);
              notification.show(300);
              form[0].reset();
              button.disabled = false;
              timeout = window.setTimeout(() => {
                form.css('opacity', 1);
                notification.hide(300);
              }, 2000);
            }
          });
        });
       });
    });
    $(document).ready(function() {
        $('.operations-content').fitVids();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js